import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  timeShiftOnVoiceToTextSeconds: number;
  recordingBufferSizeSeconds: number;
  scriptProcessorBufferSizeSamples: number;
}

export const schemaMap: SchemaOf<IConfig> = {
  timeShiftOnVoiceToTextSeconds: Joi.number(),
  recordingBufferSizeSeconds: Joi.number(),
  scriptProcessorBufferSizeSamples: Joi.number().valid(
    512,
    1024,
    2048,
    4096,
    8192,
    16384
  ),
};

export const schemaMapDefault = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  timeShiftOnVoiceToTextSeconds: 0,
  recordingBufferSizeSeconds: 2,
  scriptProcessorBufferSizeSamples: 4096,
};
